import { render, staticRenderFns } from "./homestay.vue?vue&type=template&id=7457448a&scoped=true&"
import script from "./homestay.vue?vue&type=script&lang=js&"
export * from "./homestay.vue?vue&type=script&lang=js&"
import style0 from "./homestay.vue?vue&type=style&index=0&id=7457448a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7457448a",
  null
  
)

export default component.exports